<div class="container">
  <h1 class="display-5 fw-semibold">Nuestros artículos</h1>

  <div class="row mt-4">
    <div class="col-md-7">
      <div class="row g-3 align-items-start">
        @if (categoryId) {
          @if (loading) {
            <div class="col-12 placeholder-glow">
              <span class="placeholder col-4 placeholder-lg"></span>
            </div>
          } @else {
            <h5>Categoria: {{ getCategoryName(categoryId) }}</h5>
          }
        }

        @for (article of articles; track article) {
          <div class="col-md-4">
            <a [routerLink]="['/articulo', article.id]">
              <div class="card text-bg-dark">
                <img
                  [src]="article.image_url"
                  class="card-img object-fit-cover"
                  height="180"
                  alt=""
                />
                <div class="p-2">
                  <h5 class="card-title">{{ article.title }}</h5>
                  <p class="card-text">
                    <i class="bi bi-clock"></i>
                    {{ article.date | date: 'dd/MM/yy' }}
                  </p>
                </div>
              </div>
            </a>
          </div>
        } @empty {
          @if (loading) {
            @for (placeholder of [1, 2, 3, 4, 5, 6]; track placeholder) {
              <div class="col-md-4 placeholder-glow">
                <span class="placeholder w-100" style="height: 250px"></span>
              </div>
            }
          } @else {
            <p>No hay artículos disponibles.</p>
          }
        }
      </div>
    </div>

    <div class="col-md-5">
      <h5>Por Categorías</h5>

      <div class="row g-4">
        @for (category of filterCategory; track category) {
          <a
            routerLink="/articulos/"
            [queryParams]="{ categoria: category.id }"
          >
            <div class="col-12">
              <div class="card text-bg-dark">
                <div class="p-2">
                  <h5 class="card-title mt-4">{{ category.name }}</h5>
                  <p class="card-text">
                    @if (category.quantityItems) {
                      {{ category.quantityItems }}
                      {{
                        category.quantityItems > 1 ? 'artículos' : 'artículo'
                      }}
                    }
                  </p>
                </div>
              </div>
            </div>
          </a>
        } @empty {
          @for (placeholder of [1, 2, 3]; track placeholder) {
            <div class="col-12 placeholder-glow">
              <span class="placeholder w-100" style="height: 100px"></span>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
